const initAos = () => {
    // @ts-ignore
    AOS.init({
        // Settings that can be overridden on per-element basis, by `data-aos-*` attributes:
        offset: 200,
        delay: 5,
        duration: 400,
        easing: 'ease',
        once: true,
        mirror: false,
        anchorPlacement: 'top-bottom', // defines which position of the element regarding to window should trigger the animation
    });
};
